module.exports = __webpack_public_path__ + "static/media/default_img.63cf5972.png";